'use client';

import { useLogoutMutation } from '@/redux/api/authApi';
import { setCredentials } from '@/redux/features/authSlice';
import { useAppDispatch } from '@/redux/hooks';
import { useRouter } from 'next/navigation';
import { toast } from 'sonner';

const LogoutComponent = () => {
  const [logout, { isLoading, isError, error }] = useLogoutMutation();
  const dispatch = useAppDispatch();
  const router = useRouter();

  // logout function
  const handleLogout = async () => {
    try {
      const result = await logout({}).unwrap();
      if (result?.success) {
        dispatch(setCredentials({ user: null, accessToken: null }));
        router.push('/');
        toast.success('Successfully Logged Out!', {
          description: 'You have been logged out of your account.',
          duration: 3000,

          action: {
            label: 'Go to Home',
            onClick: () => router.push('/'),
          },
        });
      }
    } catch (err) {
      toast.error('Logout Failed', {
        description: 'An error occurred while logging out. Please try again.',
        duration: 4000,
      });
    }
  };

  return {
    isLoading,
    isError,
    error,
    handleLogout,
  };
};

export default LogoutComponent;
